import { t } from "@lingui/macro";
import React from "react";

import { Box, Text } from "@whoosh/design-system/src/components/primitive";

export const NoAgendaErrorDisplay = () => {
  return (
    <Box alignItems="center" justifyContent="center" bg="grayscale-0" py={25}>
      <Text
        accessibilityRole="header"
        variant="mainTitle3"
        maxFontSizeMultiplier={2}
        mb={4}
      >
        {t`Sorry!`}
      </Text>
      <Text
        maxFontSizeMultiplier={2}
      >{t`Looks like there isn't a Tee Sheet yet for this day`}</Text>
    </Box>
  );
};
